export const GTMPageView = (page) => {
    const pageEvent = {
        event: "pagechange",
        page,
    };
    //@ts-ignore
    window && page && window.dataLayer && window.dataLayer.push(pageEvent);
    return pageEvent;
};
export const GTMAdtraction = (id, code) => {
    const event = {
        event: "adtraction_event",
        transactionId: id,
        transactionPromoCode: code,
        transactionTotal: 0,
        md5: "",
    };
    //@ts-ignore
    window && window.dataLayer && window.dataLayer.push(event);
    return event;
};
